setTimeout(() => {
    const stars = document.getElementsByClassName("spr-badge")
    const starsArray = Array.from(stars)
    starsArray.map((elem) => {
        if (elem.dataset.rating === "0.0") {
            elem.style.display = "none"
        }
        else return
    })

}, 2000);
